'use strict';

var _objectSpread = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _regeneratorRuntime = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncIterator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var multibase = require('multibase');

var _require = require('buffer'),
    Buffer = _require.Buffer;

var log = require('debug')('ipfs-http-client:pubsub:subscribe');

var SubscriptionTracker = require('./subscription-tracker');

var configure = require('../lib/configure');

var toUrlSearchParams = require('../lib/to-url-search-params');

module.exports = configure(function (api, options) {
  var subsTracker = SubscriptionTracker.singleton();

  var publish = require('./publish')(options);

  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(topic, handler) {
        var options,
            res,
            ffWorkaround,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
                options.signal = subsTracker.subscribe(topic, handler, options.signal);
                // In Firefox, the initial call to fetch does not resolve until some data
                // is received. If this doesn't happen within 1 second send an empty message
                // to kickstart the process.
                ffWorkaround = setTimeout(
                /*#__PURE__*/
                _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee() {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          log("Publishing empty message to \"".concat(topic, "\" to resolve subscription request"));
                          _context.prev = 1;
                          _context.next = 4;
                          return publish(topic, Buffer.alloc(0), options);

                        case 4:
                          _context.next = 9;
                          break;

                        case 6:
                          _context.prev = 6;
                          _context.t0 = _context["catch"](1);
                          log('Failed to publish empty message', _context.t0);

                        case 9:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[1, 6]]);
                })), 1000);
                _context2.prev = 3;
                _context2.next = 6;
                return api.post('pubsub/sub', {
                  timeout: options.timeout,
                  signal: options.signal,
                  searchParams: toUrlSearchParams(_objectSpread({
                    arg: topic
                  }, options)),
                  headers: options.headers
                });

              case 6:
                res = _context2.sent;
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](3);
                // Initial subscribe fail, ensure we clean up
                subsTracker.unsubscribe(topic, handler);
                throw _context2.t0;

              case 13:
                clearTimeout(ffWorkaround);
                readMessages(res.ndjson(), {
                  onMessage: handler,
                  onEnd: function onEnd() {
                    return subsTracker.unsubscribe(topic, handler);
                  },
                  onError: options.onError
                });

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 9]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
});

function readMessages(_x3, _x4) {
  return _readMessages.apply(this, arguments);
}

function _readMessages() {
  _readMessages = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(msgStream, _ref3) {
    var onMessage, onEnd, onError, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, msg;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            onMessage = _ref3.onMessage, onEnd = _ref3.onEnd, onError = _ref3.onError;
            onError = onError || log;
            _context3.prev = 2;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context3.prev = 5;
            _iterator = _asyncIterator(msgStream);

          case 7:
            _context3.next = 9;
            return _iterator.next();

          case 9:
            _step = _context3.sent;
            _iteratorNormalCompletion = _step.done;
            _context3.next = 13;
            return _step.value;

          case 13:
            _value = _context3.sent;

            if (_iteratorNormalCompletion) {
              _context3.next = 20;
              break;
            }

            msg = _value;

            try {
              onMessage({
                from: multibase.encode('base58btc', Buffer.from(msg.from, 'base64')).toString().slice(1),
                data: Buffer.from(msg.data, 'base64'),
                seqno: Buffer.from(msg.seqno, 'base64'),
                topicIDs: msg.topicIDs
              });
            } catch (err) {
              err.message = "Failed to parse pubsub message: ".concat(err.message);
              onError(err, false, msg); // Not fatal
            }

          case 17:
            _iteratorNormalCompletion = true;
            _context3.next = 7;
            break;

          case 20:
            _context3.next = 26;
            break;

          case 22:
            _context3.prev = 22;
            _context3.t0 = _context3["catch"](5);
            _didIteratorError = true;
            _iteratorError = _context3.t0;

          case 26:
            _context3.prev = 26;
            _context3.prev = 27;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context3.next = 31;
              break;
            }

            _context3.next = 31;
            return _iterator.return();

          case 31:
            _context3.prev = 31;

            if (!_didIteratorError) {
              _context3.next = 34;
              break;
            }

            throw _iteratorError;

          case 34:
            return _context3.finish(31);

          case 35:
            return _context3.finish(26);

          case 36:
            _context3.next = 41;
            break;

          case 38:
            _context3.prev = 38;
            _context3.t1 = _context3["catch"](2);

            // FIXME: In testing with Chrome, err.type is undefined (should not be!)
            // Temporarily use the name property instead.
            if (_context3.t1.type !== 'aborted' && _context3.t1.name !== 'AbortError') {
              onError(_context3.t1, true); // Fatal
            }

          case 41:
            _context3.prev = 41;
            onEnd();
            return _context3.finish(41);

          case 44:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 38, 41, 44], [5, 22, 26, 36], [27,, 31, 35]]);
  }));
  return _readMessages.apply(this, arguments);
}